import styled from 'styled-components';

export const CounterText = styled.span<{ $isAtLimit: boolean }>`
  font-size: 12px;
  font-weight: 400;
  font-variant-numeric: tabular-nums;
  color: ${({ $isAtLimit }) => ($isAtLimit ? 'var(--brand-warning)' : 'var(--gray)')};
  user-select: none;
`;
